import dayjs from 'dayjs';
import {
  formatInvoiceDate,
  formatAmount,
} from './helpers';

export default [
  {
    field: 'tutor',
    headerName: 'Tutor',
    type: 'text',
    flex: 2,
    valueGetter: ({ row }) => `${row.metadata.tutor.firstName} ${row.metadata.tutor.lastName}`,
  },
  {
    field: 'id',
    headerName: 'Invoice Id',
    type: 'text',
    flex: 2,
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    type: 'date',
    width: 165,
    valueGetter: ({ row }) => formatInvoiceDate(row.createdAt),
    valueFormatter: ({ value }) => dayjs(value).format('DD-MM-YYYY HH:mm'),
    filterValueGetter: ({ row }) => row.createdAt,
  },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    type: 'date',
    width: 165,
    valueGetter: ({ row }) => formatInvoiceDate(row.updatedAt),
    valueFormatter: ({ value }) => dayjs(value).format('DD-MM-YYYY HH:mm'),
    filterValueGetter: ({ row }) => row.updatedAt,
  },
  {
    field: 'lineItemsCount',
    headerName: 'Line Items',
    type: 'number',
    width: 125,
    align: 'right',
    headerAlign: 'right',
    valueGetter: ({ row }) => row.lines?.length ?? 'None',
    filterValueGetter: ({ row }) => row.lines?.length ?? 0,
  },
  {
    field: 'totalHours',
    headerName: 'Total Hours',
    type: 'number',
    width: 125,
    align: 'right',
    headerAlign: 'right',
    valueGetter: ({ row }) => row.metadata.totalHoursTutored ?? 'Unset',
    filterValueGetter: ({ row }) => Number(row.metadata?.totalHoursTutored) || 0,
  },
  {
    field: 'total',
    headerName: 'Total (Currency)',
    type: 'price',
    align: 'right',
    width: 175,
    headerAlign: 'right',
    valueGetter: ({ row }) => formatAmount(row.total, row.currency),
    filterValueGetter: ({ row }) => (row.total ?? 0) / 100,
  },
  {
    field: 'status',
    headerName: 'Status',
    type: 'multiple-choice',
    width: 175,
    align: 'center',
    headerAlign: 'center',
    valueGetter: ({ row }) => row.status.toUpperCase(),
  },
];
